import { identityConstants } from './identity-constants';

export const idenityI18nKeys = {
    PleaseEnterUserName: `PleaseEnterUserName`,
    PleaseEnterPassword: `PleaseEnterPassword`,
}